import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'layui/dist/css/layui.css'
import layui from 'layui'
import 'font-awesome/css/font-awesome.min.css'
import './assets/game-query.css'

Vue.config.productionTip = false
// 全局注入layui，方便组件使用
Vue.prototype.$layui = layui

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
